import React, { ComponentProps, FC, ReactElement } from 'react';
import {ColumnsType} from "antd/lib/table";
import {InvestigationItem} from "../../../../types";
import {StudentExerciseAttemptReportDataTableCard} from "../Generic/StudentExerciseAttemptReportDataTableCard";
import {useLabels} from "../../../../hooks/Labels";

export const columns: ColumnsType<InvestigationItem> = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: 'Frequency',
        dataIndex: 'frequency',
        key: 'frequency',
        render: (text) => `${text}%`
    },
    {
        title: 'Cost',
        dataIndex: 'cost',
        key: 'cost',
    },
    {
        title: 'Duration Est.',
        dataIndex: 'time_estimated',
        key: 'time_estimated',
    },
]

type MissedOrdersProps = Pick<
    ComponentProps<typeof StudentExerciseAttemptReportDataTableCard>, 
    'attemptId' | 'activityId'
>;
export const MissedOrdersDataTableCard: FC<MissedOrdersProps> = ({attemptId, activityId}): ReactElement => {
    const {t} = useLabels();
    return (
        <StudentExerciseAttemptReportDataTableCard
            title={t('missed_items_title')}
            columns={attemptId ? columns.filter(column => column.key !== 'frequency') : columns}
            query='/reports/investigation/missed-order-items/'
            attemptId={attemptId}
            activityId={activityId}
        />
    )
};
